<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jyzn">就医指南</router-link> >
      <router-link to="/jyzn/fenbu">楼层分布</router-link>
    </div>
    <div class="container-width x-article">
      <div class="title">楼层分布</div>
      <div v-for="(item, index) in list" :key="index" class="p50">
        <a class="h-name">{{ index }}</a>
        <ul class="ulPartList">
          <li class="li" v-for="(m, n) in item" :key="n">
            <a @click="goArticle(m.id)" class="wh_dot"> {{ m.location }}</a>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/jyzn";
import BANNER from "../../components/banner/jyzn";
export default {
  name: "FENBU",
  data() {
    return {
      navigationData: [
        {
          name: "就医须知",
          path: "/jyzn",
        },
        {
          name: "门诊就诊流程图",
          path: "/jyzn/liucheng",
        },
        {
          name: "楼层分布",
          path: "/jyzn/fenbu",
        },
        {
          name: "乘车路线",
          path: "/jyzn/luxian",
        },
        {
          name: "联系我们",
          path: "/jyzn/lianxi",
        },
      ],
      currentPath: "/jyzn/fenbu",
      articlePath: "/jyzn/fenbu/article",
      pageIndex: 1,
      pageSize: 1000,
      totalPages: 1,
      currentPage: 1,
      list: {},
      total: 0,
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: 1,
        pageSize: 1000,
      };
      service.getFloorList(parmes, (res) => {
        let list = {};
        if (res.content) {
          res.content.map((item) => {
            if (!list[item.area]) {
              list[item.area] = [{ location: item.location, id: item.id }];
            } else {
              list[item.area].push({ location: item.location, id: item.id });
            }

            this.list = list;
          });
        }
      });
    },
    goArticle(id) {
      let articleId = id || 0;
      const { href } = this.$router.resolve({
        path: `/jyzn/fenbu/article/${articleId}`,
      });
      window.open(href, "_blank");
    },
  },
  mounted() {},
  watch: {},
};
</script>


<style scoped lang="scss">
.x-article {
  padding: 20px;
}
.h-name {
  width: 100%;
  display: block;
  height: 59px;
  line-height: 59px;
  text-align: center;
  overflow: hidden;
  background: url(../../assets/title_bj1.png) no-repeat center center;
  font-size: 1.2rem;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
  background-size: 100% 100%;
}

.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;

  .title {
    padding-top: 30px;
    padding-bottom: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
    font-size: 1.8rem;
    color: #323232;
  }
}
.p50 {
  padding: 0 50px;
  box-sizing: border-box;
}

@media only screen and (max-width: 420px) {
  ul {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .h-name {
    font-size: 0.9rem;
    background-size: 240% 100%;
    height: 40px;
    line-height: 40px;
  }
  .p50 {
    padding: 0 10px;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 421px) and (max-width: 600px) {
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    li {
      a {
        font-size: 0.9rem;
        height: 40px;
        line-height: 40px;
      }
      .wh_dot:before {
        top: 18px;
      }
    }
  }
  .h-name {
    font-size: 1rem;
    background-size: 200% 100%;
    height: 40px;
    line-height: 40px;
  }
  .p50 {
    padding: 0 15px;
    box-sizing: border-box;
  }
}

@media only screen and (min-width: 601px) and (max-width: 922px) {
  .h-name {
    background: url(../../assets/title_bj1.png) no-repeat center center;
    font-size: 1rem;
    background-size: 180% 100%;
    height: 40px;
    line-height: 40px;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    li {
      a {
        font-size: 0.9rem;
        height: 40px;
        line-height: 40px;
      }
      .wh_dot:before {
        top: 18px;
      }
    }
  }

  .p50 {
    padding: 0 20px;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 923px) and (max-width: 1200px) {
  .h-name {
    font-size: 1rem;
    background-size: 150% 100%;
    height: 40px;
    line-height: 40px;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    li {
      a {
        font-size: 0.9rem;
        height: 45px;
        line-height: 45px;
      }
      .wh_dot:before {
        top: 20px;
      }
    }
  }
  .p50 {
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
